module.exports = __webpack_public_path__ + "static/media/zach.02cbfeeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/zach.jpg
// module id = 5795
// module chunks = 1